export const DEFAULT_API_BASE_URL = 'http://localhost:8090'

export const API_BASE_URL = ((import.meta.env && import.meta.env.VITE_API_BASE_URL) || DEFAULT_API_BASE_URL).replace(/\/$/, '')
